import { render, staticRenderFns } from "./PoweredByDarkSky.vue?vue&type=template&id=28445254&"
import script from "./PoweredByDarkSky.vue?vue&type=script&lang=js&"
export * from "./PoweredByDarkSky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports